exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select.no-border, select.no-border:focus {\n  border: none;\n  padding: 2px 6px 2px 2px;\n}\n.payment-info {\n  white-space: nowrap;\n}\n.payment-info img {\n  width: 32px;\n}\n.table-bordered thead th, .table-bordered thead td {\n  border-bottom-width: 1px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/mvdclick/frontend/src/app/views/acts/acts.component.css
// module id = ../../../../../src/app/views/acts/acts.component.css
// module chunks = main